var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-denied",attrs:{"m-0":"","p-0":""}},[_c('div',{staticClass:"border"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v("Acesso Negado")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('v-icon',[_vm._v("mood_bad")]),_vm._v(" "),_c('p',[_vm._v("Desculpe, parece que você não tem acesso a esta página.")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1895a509","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccessDenied.vue
// module id = 1263
// module chunks = 1